import { Injectable } from '@angular/core';
import { UtilService } from './util.service';
import { ApiService } from './api.service';
import { DataService } from './data.service';
import { TenureDetails } from './model';
import { DialogBoxService } from './dialog-box.service';
import { ConstantData } from './constants';

@Injectable({
  providedIn: 'root'
})
export class FetcherService {

  constructor(private api: ApiService, private dataS: DataService, private ds: DialogBoxService) { }

  getLoanId(showLoader: boolean = true): Promise<any> {
    return this.api.handleRequest('get', this.api.getUrl('loan_all'), undefined, undefined, undefined, undefined, showLoader).then((data: any) => data.content.find((loan: any) => loan.statusId !== 'DISCARDED'));
  }


  async getLoanDetails(showLoader: boolean = true) {
    try {
      const loanId = await this.getLoanId(showLoader);
      this.dataS.setCache('loanId', loanId?.loanId);
      if (loanId?.loanId) {
        const loanData = await this.api.handleRequest('get', this.api.getUrl('loan_details', [loanId?.loanId]), undefined, undefined, undefined, undefined, showLoader);

        this.dataS.setCache('loanData', loanData.content);

        const product = this.dataS.getCache('products').find((pro: any) => pro.id === loanData.content.product);
        const productCat = product.category.find((cat: any) => cat.id === loanData.content.productCategory);
        this.dataS.setCache('currentApplicant', loanData.content.loanApplicantDetails[loanData.content.loanApplicantDetails.length - 1].id);
        this.dataS.setCache('productCat', productCat);
        this.dataS.setCache('product', product);


      }

      return loanId;
    } catch (err) {
    }


  }


  async updateCommercials(loanDetails: any, selectedTenure: TenureDetails, isWithMoratoriumSelected:boolean = false) {

    const loanId = loanDetails.loanId;
    if (loanDetails.isMaOlderThen55() && loanDetails.isInsuranceAdditionNotCompleted) {
      await this.api.handleRequest('put', this.api.getUrl('loan_insuranceDetails', [loanId]), {
        'insuranceApplicable': false,
      });

    }

    const body = loanDetails.hasMoratorium && isWithMoratoriumSelected ? {
      'loanId': loanId,
      'amount': selectedTenure.amount,
      'tenorMonths': selectedTenure.selectedTenor?.tenor,
      'moratorium': true,
      'moratoriumPeriod': loanDetails.institutionInfo?.moratoriumPeriod
    }
      :
      {
        'loanId': loanId,
        'amount': selectedTenure.amount,
        'tenorMonths': selectedTenure.selectedTenor!.tenor,
      };

    return this.api.handleRequest('put', this.api.getUrl('loan_updateCommercials_v2'), body);



  }

  submitLoan(loan: any, currentApplicant: any, callBack: any) {
    this.api.handleRequest('put', this.api.getUrl('loan_review_submit', [loan.loanId]), undefined, undefined, undefined, undefined, false).then((res: any) => {
      this.ds.showwaitingDialog(ConstantData.waitingScreenStatus.waitingScreen);
      this.getLoanDetails(false).then(() => {
        callBack();
      });
    });

  }

  updateESigned(loan: any, showLoader:boolean = true) {
    return this.api.handleRequest('get', this.api.getUrl('loan_eSignStatus', [loan.loanId]), undefined, undefined,undefined,undefined,showLoader).then((res: any) => {
      const applicants = this.dataS.getCache('loanData').loanApplicantDetails.map((applicant:any)=> res.content.signerDetails.find((signerD:any)=> signerD.personId == applicant.id));
      this.dataS.setCache('loanData', { ...this.dataS.getCache('loanData'), eSignStatusModel: {...res.content,signerDetails: applicants} });
      return res;
    });
  }

  searchAllCoursesInstitudes(name:string, pageNo:number = 0, pageSize:number = 10, isLoading:boolean = false){
    return this.api.handleRequest('get', this.api.getUrl('courses_v2all', [name,pageNo,pageSize]),undefined,undefined,undefined,undefined,isLoading);
  }
}
